module.exports = __webpack_public_path__ + "files/b0fc6e87a8a979a6922d3c1701dc6eaf.png";